import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import style from "./NotFoundError.module.css";

const NotFoundError = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  return (
    <div className="flex flex--justify-center flex--align-center h100">
      <div className={style.container}>
        <h1>Sidan kan inte hittas!</h1>
        <p className="body1 light">
          Det kan bero på flera saker. Länken från föregående sida är bruten.
          URL:en är fel (kontrollera att den inte innehåller några stavfel)
          eller så har sidan tagits bort eller flyttats.
        </p>
      </div>
    </div>
  );
};

export default NotFoundError;
